import { CAPTCHA_SITE_KEY, SITE_KEY } from "@utils/Constant";

export const getCorrectSiteKey = (): string => {
  switch (window.location.host) {
    case SITE_KEY.recette.environnement: {
      return SITE_KEY.recette.key;
    }
    case SITE_KEY.preprod.environnement: {
      return SITE_KEY.preprod.key;
    }
    case SITE_KEY.prod.environnement: {
      return SITE_KEY.prod.key;
    }
    default: {
      return CAPTCHA_SITE_KEY;
    }
  }
};
